import { Component, DestroyRef, inject, ChangeDetectionStrategy } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NavigationStart, Router } from '@angular/router';
import { filter } from 'rxjs';
import { TranslatePipe } from '@ngx-translate/core';
import { ModalResult } from '../../interfaces/modal-result.interface';
import { CartService } from '../../services/cart.service';
import { CartComponent } from '../cart/cart.component';
import { IconComponent } from "../icon/icon.component";

export interface CartModalData {
  sourceForAnalytics: string;
}

@Component({
  selector: 'cart-modal',
  templateUrl: './cart-modal.component.html',
  styleUrls: ['./cart-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [CartComponent, TranslatePipe, IconComponent]
})
export class CartModalComponent {
  protected readonly dialogRef = inject(MatDialogRef<CartModalComponent, ModalResult>);
  protected readonly data = inject<CartModalData>(MAT_DIALOG_DATA);
  private readonly router = inject(Router);
  private readonly destroyRef = inject(DestroyRef);

  protected cartService = inject(CartService);

  constructor() {
    this.router.events
      .pipe(
        filter((e): e is NavigationStart => e instanceof NavigationStart),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe(() => this.dialogRef.close());
  }
}
